import Axios, { AxiosInstance } from 'axios';
import AuthApi from './session';
import WebsitesApi from './websites';
import StatisticsApi from './statistics';

class Api {
  public readonly auth: AuthApi;
  public readonly websites: WebsitesApi;
  public readonly statistics: StatisticsApi;

  constructor(axios: AxiosInstance) {
    this.auth = new AuthApi(axios);
    this.websites = new WebsitesApi(axios);
    this.statistics = new StatisticsApi(axios);
  }
}

const createAxiosInstance = () => {
  const username = sessionStorage.getItem('username');
  const password = sessionStorage.getItem('password');
  if (username && password) {
    return Axios.create({
      auth: {
        username: username,
        password: password
      },
      baseURL: `${process.env.REACT_APP_BACKEND_HOST}`,
    });
  }
  return Axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND_HOST}`,
  });
}

export const axiosInstance = createAxiosInstance();

export const api = new Api(axiosInstance);
